'use strict';

var _interopRequireDefault = require('babel-runtime/helpers/interop-require-default')['default'];

exports.__esModule = true;

var _Loader2 = require('./Loader');

var _Loader3 = _interopRequireDefault(_Loader2);

exports.Loader = _Loader3['default'];

var _LoadingButton2 = require('./LoadingButton');

var _LoadingButton3 = _interopRequireDefault(_LoadingButton2);

exports.LoadingButton = _LoadingButton3['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./src/reactis/reactis-loader/src/index.js
 ** module id = 80
 ** module chunks = 1
 **/